<template>
  <div class="a">
    <Nav/>
    <PageBannerBig :banner="banner"></PageBannerBig>
    <div class="service-content">
      <div class="content">
        <div class="title-name">银行业解决方案</div>
        <div class="title-sub">概述</div>
        <div class="text">
          随着银行信息科技治理水平的提高，围绕科技创新探索更加合理的资源结构和成本结构，成为提高信息科技投入产出比加快科技创新推动产业升级的重要手段。
          以离岸开发/测试为形态建设更加高效的低成本开发测试体系正在成为越来越多的金融机构科技战略的重要手段。
        </div>
        <div class="title-sub">解决方案</div>
        <div class="text">
          离岸开发/测试中心是建立在完善的信息安全保障前提下，并符合银监会相关非驻场信息技术外包服务有关要求，包含了必要的基础设施、资源配置，以及完善的制度体系、监控体系、管理体系的综合解决方案。<br>
          基础解决方案<br>
          场地配置、门禁管理、视频监控、安保管理、网络配置等。<br>
          场地建设根据客户的要求提供场地建设服务<br>
          场地选址、场地装修、机房建设、办公场地配置、门禁及视频监控系统安装、场地管理。<br>
          ODC\OTC运营管理<br>
          ODC\OTC运营管理工作例会制度、场地巡视制度、机房巡视制度、应急响应制度、ODC\OTC服务人员绩效考核办法、ODC\OTC服务客户满意度调查问卷。<br>
          ODC\OTC场地管理<br>
          人员出入及工卡管理、外援入场审批制度、外援离场审批制度、驻场工作规范、环境资源及设备管理、故障报修制度、信息安全管理制度、延时工作申请制度、安防响应制度、会议申请制度、后勤保障。
        </div>
        <div class="title-sub">能力优势</div>
        <div class="text">
          场地建设能力<br>
          根据客户的场地要求，提供一站式场地建设服务。<br>
          场地管理能力<br>
          根据客户的管理要求，提供全方位的场地管理支持。
        </div>
        <div class="title-sub">客户收益</div>
        <div class="text">
          通过场地建设，客户能够获得如下的收益：<br>
          减少成本支出。<br>
          加强了外包人员管理。<br>
          降低了非驻场集中式外包服务风险。
        </div>
      </div>
      <Mission/>
    </div>

    <Contact/>
    <Footer/>
  </div>
</template>

<script>
import Nav from '@/components/Nav'
import PageBannerBig from '@/components/PageBannerBig'
import Contact from '@/components/Contact'
import Footer from '@/components/Footer'
export default {
  name: '',
  components: {
    Nav,
    PageBannerBig,
    Contact,
    Footer
  },
  data () {
    return {
      banner: {
        img: require("@/assets/img/solution-banner.jpg"),
        title: "为您提供专业的解决方案",
        sub: "专业的服务 高效的方案"
      }
    }
  }
}
</script>

<style scoped lang="less">
.service-content{
    width: 100%;
    padding-bottom: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    background-image: url(../../assets/img/service-bg.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .content{
      width: 1200px;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      .title-name{
        height: 38px;
        color: #333333;
        transform: .5s;
        line-height: 38px;
        font-size: 30px;
        margin-top: 80px;
        margin-bottom: 38px;
        text-align: center;
        box-sizing: border-box;
      }
      .title-sub{
        color: #333;
        line-height: 24px;
        font-size: 20px;
        text-align: left;
        box-sizing: border-box;
        width: 200px;
        margin-top: 30px;
        margin-bottom: 10px;
        border-radius: 30px;
      }
      .text{
        color: #666;
        line-height: 24px;
        font-size: 14px;
        box-sizing: border-box;
      }
    }
}
</style>